import { ContoDTO } from "./contoDTO";

export class ContoCapienzaDTO {
  esercizio: string;
  periodo: string;
  conti: ContoDTO[];
}
